<template>
    <!-- Expansion Panels for Entry Content -->
    <div v-if="getEntries.length > 0" class="d-flex justify-end mb-2">
        <v-btn-toggle>
            <v-btn v-show="expandValue == 0" @click="setPanels(0)" icon="mdi-arrow-collapse" />
            <v-btn v-show="expandValue == 1" @click="setPanels(1)" icon="mdi-arrow-expand" />
        </v-btn-toggle>
    </div>
    <v-expansion-panels v-model="openedPanels" multiple>
        <v-expansion-panel v-for="(entry, i) in getEntries" :key="i" v-model="openedPanels[i]">
            <template v-slot:title>
                {{ entry.dateString }}
            </template>

            <v-expansion-panel-text>
                <v-card class="mb-2">
                    <v-card-title class="bg-aqua-teal text-center text-wrap mb-2" v-if="entry.title != null">
                        {{ entry.title }}
                    </v-card-title>
                    <v-card-text>
                        <v-textarea variant="outlined" color="aqua-teal" 
                        v-model="entry.entry" rows="2" max-rows="10" :readonly="true" auto-grow/>
                    </v-card-text>
                </v-card>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
export default {
    name: "EntryPanel",
    data() {
        return {
            openedPanels: [],
            expandValue: 1,
        }
    },
    props: {
        entries: {
            type: Array,
        }
    },
    computed: {
        getEntries() {
            if (this.entries) {
                for (let i = 0; i < this.entries.length; i++) {

                    // Set human readable date strings
                    let date = new Date(this.entries[i].entryDate);
                    // eslint-disable-next-line
                    this.entries[i]['dateString'] = date.toDateString().substring(4);
                }
            }
            return (this.entries) ? this.entries : [];
        },
    },
    methods: {
        setPanels(value) {
            if (this.entries) {
                this.openedPanels = [];
                if (value === 1) {
                    for (let i = 0; i < this.entries.length; i++) {
                        this.openedPanels.push(i);
                    }
                }
            }
        },
    },
    watch: {
        openedPanels() {
            if (this.entries) {
                if (this.openedPanels.length === this.entries.length) {
                    this.expandValue = 0;
                } else if (this.openedPanels.length === 0) {
                    this.expandValue = 1;
                }
            }
        },
        entries() {
            if (this.entries) {
                this.setPanels(0);
            }
        }
    }
}
</script>

<style>
.bg-aqua-teal {
    background-color: #08B6AA;
}
</style>